import type { ChartType } from '@/features/_shared/chart/types/highcharts';
import { canExportWidget } from '@/features/dashboard';
import type { FormAppWidget } from '@/features/dashboard';
import { CsvWidgetExportButton, ExportChartButton } from '@/features/data-hub';
import { useOptionalMarketWidget } from '@/features/markets/components/contexts/MarketWidgetContext';
import ExportWidgetButton from '@/features/markets/components/ExportWidgetButton';
import type { BaseTabType } from '@/features/markets/types';
import CustomDownloadChartButton from '../CustomDownloadChartButton';

export const isTabExportSupported = (tab: BaseTabType): boolean => {
  if (tab.type === 'graph' && tab.metadata?.graphType === 'static') {
    return false;
  }

  if (tab.type === 'graph' || tab.type === 'csvtable' || tab.type === 'minitable') {
    return true;
  }

  if (tab.type === 'spot_history_table') {
    return Boolean(tab.columns.length) && canExportWidget(tab as FormAppWidget);
  }

  return canExportWidget(tab as FormAppWidget);
};

const TabExportButton = ({ tab }: { tab: BaseTabType }) => {
  const { isFullScreen } = useOptionalMarketWidget();

  if (!isTabExportSupported(tab)) {
    return null;
  }

  if (tab.type === 'graph') {
    return tab.metadata?.graphType === 'custom' ? (
      <CustomDownloadChartButton
        metadata={tab.metadata}
        tabName={tab.name}
      />
    ) : (
      <ExportChartButton
        graphType={tab.metadata?.graphType as ChartType}
        isFullScreen={isFullScreen}
        metadata={tab.metadata}
        tabName={tab.name}
      />
    );
  }
  if (tab.type === 'csvtable') {
    return <CsvWidgetExportButton tabName={tab.name} />;
  }
  return <ExportWidgetButton tab={tab} />;
};

export default TabExportButton;
